import React from 'react';
import { JobSourceFeature, FormErrors } from '../types';

interface BasicInfoSectionProps {
  formData: JobSourceFeature;
  setFormData: (data: JobSourceFeature) => void;
  errors: FormErrors;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  formData,
  setFormData,
  errors,
}) => {
  const handleChange = (field: keyof JobSourceFeature, value: string | number | boolean) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          特徴名 <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${errors.name ? 'is-invalid' : ''}`}
          id="name"
          value={formData.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
        {errors.name && <div className="invalid-feedback">{errors.name.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="description" className="form-label">
          説明
        </label>
        <textarea
          className={`form-control ${errors.description ? 'is-invalid' : ''}`}
          id="description"
          rows={3}
          value={formData.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
        />
        {errors.description && <div className="invalid-feedback">{errors.description.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="synonyms" className="form-label">
          同義語
        </label>
        <textarea
          className={`form-control ${errors.synonyms ? 'is-invalid' : ''}`}
          id="synonyms"
          rows={3}
          value={formData.synonyms || ''}
          onChange={(e) => handleChange('synonyms', e.target.value)}
          placeholder="同義語を改行区切りで入力してください"
        />
        <div className="form-text">同義語を改行区切りで入力してください。</div>
        {errors.synonyms && <div className="invalid-feedback">{errors.synonyms.join(', ')}</div>}
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="display_priority" className="form-label">
              表示優先度
            </label>
            <input
              type="number"
              className={`form-control ${errors.display_priority ? 'is-invalid' : ''}`}
              id="display_priority"
              min="0"
              value={formData.display_priority || 100}
              onChange={(e) => handleChange('display_priority', parseInt(e.target.value, 10) || 100)}
            />
            <div className="form-text">数値が小さいほど上位に表示されます。</div>
            {errors.display_priority && <div className="invalid-feedback">{errors.display_priority.join(', ')}</div>}
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="slug" className="form-label">
              スラッグ
            </label>
            <input
              type="text"
              className={`form-control ${errors.slug ? 'is-invalid' : ''}`}
              id="slug"
              value={formData.slug || ''}
              onChange={(e) => handleChange('slug', e.target.value)}
              placeholder="自動生成されます"
            />
            <div className="form-text">URL用のスラッグ。空欄の場合は自動生成されます。</div>
            {errors.slug && <div className="invalid-feedback">{errors.slug.join(', ')}</div>}
          </div>
        </div>
      </div>

      <div className="mb-3">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="published"
            checked={formData.published || false}
            onChange={(e) => handleChange('published', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="published">
            公開する
          </label>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;

